const StaffDashboard: React.FC = () => {
  return (
    <div>
      <div style={{ marginTop: "15px" }}>
        <iframe
          src="https://statistiques.lincassable.com/public/dashboard/47e1dea6-6a31-4e45-ac48-dcaaf13b8e43"
          frameBorder="0"
          width="100%"
          height="800"
          allowTransparency
        ></iframe>
      </div>
    </div>
  );
};

export default StaffDashboard;
